import { api } from "./http-client";
import { DashboardStats } from "../types/dashboard";

export const dashboardService = {
  getStats: async (): Promise<DashboardStats[]> => {
    const response = await api.request<DashboardStats[]>({
      url: "/dashboard/stats",
      method: "GET",
    });
    return response.data;
  },
};
